var React = require('react');

var VisPercent = React.createClass({
    render : function(){
        var percent = this.props.percent && this.props.percent.length ? this.props.percent : [0,0];
        var values = this.props.values || [];
        var colors = this.props.colors || ["#ffc300", "#d31346"];
        var awayColor = colors[1];
        var homeColor = colors[0];
        var backgroundColor = percent[0] > 100 ? awayColor : homeColor;

        if(percent[0] == 0 && percent[1] == 0){
            awayColor = '#e5e5e5';
        }

        return (
            <div className={"stat-graph compareLineGraph twoTeam largeLabels" + (this.props.large ? " large" : "")}>
                <span className="chartValue">{!isNaN(values[0]) ? values[0] : percent[0] + "%"}</span>
                <div className="bar-wrap">
                    <span style={{"backgroundColor":awayColor}} className="bar-total">
                        <span style={{"backgroundColor":backgroundColor, "width":percent[0]+ "%"}} className="bar-percentage"></span>
                    </span>
                    <span className="chartValue">{!isNaN(values[1]) ? values[1] : percent[1] + "%"}</span>
                </div>
            </div>
        );
    }
});

module.exports = VisPercent;



/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/rugby/game/VisPercent.jsx
 **/